import { MAX_GPX_BYTES } from "./utils.js";

export function parseGpxPoints(gpxText) {
  const xml = new DOMParser().parseFromString(gpxText, "application/xml");
  if (xml.querySelector("parsererror")) {
    throw new Error("Invalid GPX XML.");
  }

  const nodes = Array.from(xml.getElementsByTagName("trkpt"));
  if (!nodes.length) {
    nodes.push(...Array.from(xml.getElementsByTagName("rtept")));
  }

  const points = nodes.map((node) => {
    const elevationNode = node.getElementsByTagName("ele")[0];
    const latitude = Number(node.getAttribute("lat"));
    const longitude = Number(node.getAttribute("lon"));
    const elevation = elevationNode ? Number(elevationNode.textContent) : NaN;

    return { latitude, longitude, elevation, smoothedElevation: elevation, distance: 0 };
  }).filter((point) => Number.isFinite(point.latitude) && Number.isFinite(point.longitude) && Number.isFinite(point.elevation));

  if (points.length < 2) {
    throw new Error("The GPX file needs at least two points with elevation data.");
  }

  return points;
}

export async function fetchGpxText(urlValue) {
  const url = normalizeSameOriginGpxUrl(urlValue);
  const response = await fetch(url.href, { credentials: "same-origin" });
  if (!response.ok) {
    throw new Error(`Unable to fetch GPX file (${response.status}).`);
  }

  const contentLength = response.headers.get("Content-Length");
  if (contentLength && Number(contentLength) > MAX_GPX_BYTES) {
    throw new Error("The GPX file is too large.");
  }

  const text = await response.text();
  if (text.length > MAX_GPX_BYTES) {
    throw new Error("The GPX file is too large.");
  }

  return text;
}

export function readFileAsText(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsText(file);
  });
}

function normalizeSameOriginGpxUrl(urlValue) {
  let url;
  try {
    url = new URL(urlValue, window.location.origin);
  } catch (error) {
    throw new Error("Invalid GPX URL.");
  }

  if (url.origin !== window.location.origin || !["http:", "https:"].includes(url.protocol) || !url.pathname.toLowerCase().endsWith(".gpx")) {
    throw new Error("The GPX URL must be a same-site .gpx file.");
  }

  return url;
}
